import { render, staticRenderFns } from "./StartForm11.vue?vue&type=template&id=68a122f7&scoped=true"
import script from "./StartForm11.vue?vue&type=script&lang=ts"
export * from "./StartForm11.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a122f7",
  null
  
)

export default component.exports